export default __webpack_public_path__ + "static/media/roboto-black-webfont.3a89c567.woff2";